import {Injectable} from '@angular/core';
import {AdminService} from '../../../../services/admin.service';
import {AnswerGroupPos} from './answer-group-pos.model';

@Injectable()
export class TreeGroupPosService {

  // This array set to service and send to server
  private readeForServer: AnswerGroupPos[] = [];
  private readeForServerOnlyConfirm: AnswerGroupPos[] = [];

  private foundGroupConfirm: boolean;
  private foundGroupExecute: boolean;
  private foundPosExecute: boolean;

  constructor() {
  }

  // READY FOR SERVER
  getReadeForServer() {
    return this.compareTwoArrays();
    // return this.readeForServer;
  }

  setReadeForServer(selectedList: AnswerGroupPos[]) {
    this.readeForServer = selectedList;
  }

  // USE IT FOR CHECK VALIDATION
  isValid() {
    // If one or more groups was selected return true
    return this.readeForServer.length > 0 || this.readeForServerOnlyConfirm.length > 0;
  }

  setReadeForServerOnlyConfirm(selectedListOnlyConfirm: AnswerGroupPos[]) {
    this.readeForServerOnlyConfirm = selectedListOnlyConfirm;
  }

  // Сравнить группы для исполнения с группами для утверждения и проставить onlyHeadConfirm true/false, id, []
  compareTwoArrays() {
    this.readeForServerOnlyConfirm.forEach(oc => {
      if (this.isSelectedGroupExecute(oc)) {
        // Если есть уже по позициям
        if (this.readeForServer.length > 0) {
          for (const grp of this.readeForServer) {
            if (grp.id === oc.id) {
              grp.onlyHeadConfirm = true;
              break;
          }
        }   
      } 
    } else {
        this.readeForServer.push(oc); 
    }
    });

    // No select
    this.readeForServer.forEach(rfs => {
      if (!this.isSelectedGroupConfirm(rfs)) {
        rfs.onlyHeadConfirm = false;
      }
    });

    return this.readeForServer;
  }


  // Check if group checkbox is checked
  isSelectedGroupExecute(group) {
    this.foundGroupExecute = false;
    if (this.readeForServer.length > 0) {
      for (const grp of this.readeForServer) {
        if (grp.id === group.id) {
          this.foundGroupExecute = true;
          break;
        }
      }
    }
    return this.foundGroupExecute;
  }

  // TODO if false then set FALSE
  isSelectedGroupConfirm(group) {
    this.foundGroupConfirm = false;
    if (this.readeForServerOnlyConfirm.length > 0) {
      for (const grp of this.readeForServerOnlyConfirm) {
        if (grp.id === group.id) {
          this.foundGroupConfirm = true;
          break;
        }
      }
    }
    return this.foundGroupConfirm;
  }

  // Check if position checkbox is checked
  isSelectedPosExecute(pos, group) {
    this.foundPosExecute = false;
    if (this.readeForServer.length > 0) {
      // Get all positions of this group and check this pos
      const index = this.readeForServer.findIndex(x => x.id === group.id);
      if (index !== -1) {
        for (const ps of this.readeForServer[index].positions) {
          if (ps.id === pos.id) {
            this.foundPosExecute = true;
            break;
          }
        }
      }
    }
    return this.foundPosExecute;
  }

  // Use if component is leaving
  clearPositionsForServerLists() {
    this.readeForServer = [];
    this.readeForServerOnlyConfirm = [];
  }


}



// WEBPACK FOOTER //
// C:/work/new2/internal-frontend/src/app/content-page/admin/create-operating-standard/tree-group-pos-service/tree-group-pos.service.ts